import React from "react";

import usePaymentContext from "../../provider";
import useCheckoutStepsOffersContext from "@CheckoutStepsOffers/provider";

import PixSVG2 from "@payment/assets/PixSVG2";

import AddressForm from "@CheckoutStepsOffers/components/templates/AddressForm";
import SectionHeader from "@CheckoutStepsOffers/components/templates/SectionHeader";

import { WrapperInputs } from "@CheckoutStepsOffers/styles/WrapperInputs";

import {
  Strong,
  Widget,
  Container,
  ClockIcon,
  ShieldIcon,
  Description,
} from "./styles";

const BillingInformationForm = () => {
  const { offer, methodPaymentSelected, setMethodPaymentSelected } =
    useCheckoutStepsOffersContext();
  const { formRef } = usePaymentContext();

  const widgetOnClick = () => setMethodPaymentSelected("pix");

  return (
    <Container>
      {(offer.offer.details.ask_for_address ||
        (methodPaymentSelected === "boleto" &&
          !offer.offer.details.enable_default_address)) && (
        <SectionHeader title="Dados para Nota Fiscal eletrônica" />
      )}

      {offer.offer.details.ask_for_address ? (
        <AddressForm formRef={formRef} />
      ) : (
        methodPaymentSelected === "boleto" &&
        !offer.offer.details.enable_default_address && (
          <AddressForm formRef={formRef} />
        )
      )}

      {methodPaymentSelected === "boleto" ? (
        <WrapperInputs>
          <Widget>
            <Strong>
              <ClockIcon />
              Aguarde a aprovação!
            </Strong>

            <Description>
              Pagamentos com boleto bancário levam até 3 dias úteis para serem
              confirmados.
            </Description>
          </Widget>

          {!!offer.offer.details.payment_methods.pix ? (
            <Widget onClick={widgetOnClick}>
              <Strong>
                <PixSVG2 />
                Pague com Pix
              </Strong>

              <Description>
                Pagando com Pix você tem acesso imediato ao conteúdo após a
                confirmação do pagamento.
              </Description>
            </Widget>
          ) : (
            <Widget>
              <Strong>
                <ShieldIcon />
                Onde pagar?
              </Strong>

              <Description>
                Você pode realizar o pagamento do boleto através do seu
                aplicativo bancário!
              </Description>
            </Widget>
          )}
        </WrapperInputs>
      ) : (
        <WrapperInputs>
          <Widget>
            <Strong>
              <ClockIcon />
              Tenha acesso imediatamente!
            </Strong>

            <Description>
              Após a confirmação do pagamento o acesso ao conteúdo é liberado
              instantaneamente.
            </Description>
          </Widget>

          <Widget>
            <Strong>
              <ShieldIcon />
              Compre com segurança!
            </Strong>

            <Description>
              Desenvolvido pelo Banco Central, o Pix facilita suas compras e
              assegura a proteção dos seus dados.
            </Description>
          </Widget>
        </WrapperInputs>
      )}
    </Container>
  );
};

export default BillingInformationForm;
